import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { TransportManagementSearchCriteria } from '../../transport-management/models';
import { ShipmentEndpoint } from '../constants';
import { ExportType } from '../../../../constants/status.constant';

@Injectable({ providedIn: 'root' })
export class ShipmentExportService {
  private readonly url = `${API_URL}${ShipmentEndpoint.Shipment}${ShipmentEndpoint.Exports}`;
  constructor(private http: WrapperHttpService) {}

  startExportToFile(body: {
    reportName: string;
    reportType: ExportType;
    searchRequestView: Partial<TransportManagementSearchCriteria>;
  }): Observable<void> {
    return this.http.withLoading().post<void>(this.url, body);
  }
}
